import { createAction } from '@reduxjs/toolkit';
import {
	DeviceConfCodeRequestBody,
	DeviceConfCodeResponse,
} from '@Types/deviceConfig.types';
import {
	CertificateStatusResponse,
	CertificateStatusUpdateRequestWithThingName,
} from '@Types/certificateStatus.types';
import { BuildStatus, DeploymentOptions } from '@Types/implementation';
import { addNamespace } from '@Utils/actions';
import { createActionName, toThunk } from './helpers';

const CTX = 'configurations';
const GEN_CODE = 'generateCode';
// ? Action names
const GENERATE_CODE = createActionName(CTX, GEN_CODE);
const GENERATE_CODE_DYNAMIC = createActionName(GENERATE_CODE, 'dynamic');
// ? Thunks
const G_C_THUNK = toThunk(GENERATE_CODE_DYNAMIC);

export type DeployGreengrassV2Payload = {
	deploymentOption?: DeploymentOptions;
	newApi: boolean;
};
export const deployGreengrassV2 = createAction<DeployGreengrassV2Payload>(
	addNamespace('configurations/deployGreengrassV2'),
);
export const deployGreengrassV2Resolved = createAction(
	addNamespace('configurations/deployGreengrassV2/resolved'),
);
export const deployGreengrassV2Rejected = createAction(
	addNamespace('configurations/deployGreengrassV2/rejected'),
);

export const deployDevice = createAction(addNamespace('device/deploy'));

export const generateMsiFile = createAction<{ global: boolean }>(
	addNamespace('configurations/generateInstaller'),
);
export const generateMsiFileResolved = createAction(
	addNamespace('configurations/generateInstaller/resolved'),
);
export const generateMsiFileRejected = createAction(
	addNamespace('configurations/generateInstaller/rejected'),
);
export const blockMsiFileRegenerate = createAction(
	addNamespace('configurations/generateInstaller/block'),
);

export const genConfCodeExpire = createAction(
	addNamespace('configurations/generateCode/expire'),
);
export const genConfCode = createAction<DeviceConfCodeRequestBody>(
	addNamespace('configurations/generateCode'),
);
export const genConfCodeResolved = createAction<DeviceConfCodeResponse>(
	addNamespace('configurations/generateCode/resolved'),
);
export const genConfCodeRejected = createAction(
	addNamespace('configurations/generateCode/rejected'),
);

export const genConfCodeDynamic = createAction<DeviceConfCodeRequestBody>(
	G_C_THUNK.action,
);
export const genConfCodeDynamicResolved = createAction<DeviceConfCodeResponse>(
	G_C_THUNK.resolved,
);
export const genConfCodeDynamicRejected = createAction(G_C_THUNK.rejected);

export const getCertStatus = createAction<string>(
	addNamespace('certificate/checkStatus'),
);
export const getCertStatusResolved = createAction<CertificateStatusResponse>(
	addNamespace('certificate/checkStatus/resolved'),
);
export const getCertStatusRejected = createAction(
	addNamespace('certificate/checkStatus/rejected'),
);

export const setCertStatus =
	createAction<CertificateStatusUpdateRequestWithThingName>(
		addNamespace('certificate/updateStatus'),
	);

export const setCertStatusResolved = createAction<CertificateStatusResponse>(
	addNamespace('certificate/updateStatus/resolved'),
);
export const setCertStatusRejected = createAction(
	addNamespace('certificate/updateStatus/rejected'),
);

export const checkStatusMsiFile = createAction<{ global: boolean }>(
	addNamespace('configurations/checkStatusInstaller'),
);
export const checkStatusMsiFileResolved = createAction<{
	buildStatus: BuildStatus;
}>(addNamespace('configurations/checkStatusInstaller/resolved'));
export const checkStatusMsiFileRejected = createAction(
	addNamespace('configurations/checkStatusInstaller/rejected'),
);

export const getDownloadMsiInstallerUrl = createAction<{ global: boolean }>(
	addNamespace('configurations/getDownloadMsiInstallerUrl'),
);

export const getDownloadMsiInstallerUrlResolved = createAction<{
	downloadUrl: string;
}>(addNamespace('configurations/getDownloadMsiInstallerUrl/resolved'));

export const getDownloadMsiInstallerUrlRejected = createAction(
	addNamespace('configurations/getDownloadMsiInstallerUrl/rejected'),
);

export const getConfigV2Zip = createAction(
	addNamespace('configurations/getConfigV2Zip'),
);

export const getConfigV2ZipResolved = createAction<BlobPart>(
	addNamespace('configurations/getConfigV2Zip/resolved'),
);

export const getConfigV2ZipRejected = createAction(
	addNamespace('configurations/getConfigV2Zip/rejected'),
);
